import cn from 'classnames';
import React, { useEffect, useState } from 'react';

import { ArrowUpIcon } from '@/Components/Icons';

import S from './styles.module.scss';

export const ScrollToTopButton = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setVisible(window.scrollY > 400);
        };

        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button className={cn(S.button, { [S['button-visible']]: visible })} onClick={scrollToTop} aria-label="Scroll to top">
            <ArrowUpIcon width={25} height={25} />
        </button>
    );
};
